
import React, { useState } from "react";
import VerdienstbescheinigungArbeitgebers from "./VerdienstbescheinigungArbeitgebers";




const VerdienstbescheinigungArbeitgebers1 = (props) => {
    const { accessToken, hsutkey } = props;
    const [reactnummer] = useState("842")
    const [merkmal] = useState("VerdienstbescheinigungArbeitgeber1")
    

    return (
        <div>
            <VerdienstbescheinigungArbeitgebers reactNummer={reactnummer} merkMal={merkmal} token={accessToken} hsut={hsutkey} von="05/2022" bis="09/2022" ></VerdienstbescheinigungArbeitgebers>
        </div>
    );
}

export default VerdienstbescheinigungArbeitgebers1